import { useEffect, useState } from "react";
import Modal from "./Modal";

export default function ApiErrorModal() {
  const [apiError, setApiError] = useState("");

  useEffect(() => {
    const handleApiError = (event: Event) => {
      const customEvent = event as CustomEvent<{ message?: string }>;
      setApiError(customEvent.detail?.message || "Ocurrio un error al procesar la solicitud.");
    };

    window.addEventListener("api-error", handleApiError);
    return () => window.removeEventListener("api-error", handleApiError);
  }, []);

  if (!apiError) return null;

  return (
    <Modal
      title="Error"
      onClose={() => setApiError("")}
      footer={
        <button type="button" className="btn btn-primary" onClick={() => setApiError("")}>
          Aceptar
        </button>
      }
    >
      <p className="mb-0">{apiError}</p>
    </Modal>
  );
}
